<section id="main" class="bg-light">
  <div class="container">
    <div class="card shadow-sm rounded-0 border-0">
      <div class="card-body text-center">
        <img
          src="assets/content/css/images/psp-icon/psp-old-logo.png"
          class="logo mb-2"
          [alt]="'notFoundImage' | translator:'base'"
        />
        <h1 [innerHtml]="'notFound' | translator:'base'">Not found</h1>
        <p class="mb-4" [innerHtml]="'wrongRoute' | translator:'base'">
          The page you're looking for cannot be found. Sorry.
        </p>
        <a 
          routerLink="/home" 
          class="btn btn-primary"
          id="goHome" 
          name="goHome"
          [innerHtml]="'returnHome' | translator:'base'"
          [title]="'returnHome' | translator:'base'"
        >Return home</a>
      </div>
    </div>
  </div>
</section>

